import { forwardRef } from 'react';
import { Button, ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const SecondaryButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => (
    <Button
      ref={ref}
      variant="secondary"
      className={cn(className)}
      {...props}
    />
  )
);
SecondaryButton.displayName = 'SecondaryButton';

export default SecondaryButton;
